<script lang="ts">
  import * as Table from '$lib/components/ui/table';
  import { disciplineLabel, formatEffortDuration, isDeprecatedAthleteName, valuePrecision, zoneColorForIndex, type RadarEntry } from './rankingsTypes';
  import { round } from '@/Util/utils';

  export let entries: RadarEntry[] = [];
</script>

<Table.Root>
  <Table.Header>
    <Table.Row>
      <Table.Head>Discipline</Table.Head>
      <Table.Head class="text-right">You</Table.Head>
      <Table.Head class="text-right">Median</Table.Head>
      <Table.Head class="text-right">Top 10%</Table.Head>
      <Table.Head class="text-right">Percentile</Table.Head>
    </Table.Row>
  </Table.Header>
  <Table.Body>
    {#each entries as e, i}
      <Table.Row>
        <Table.Cell>
          <div class="flex items-center gap-2.5">
            <span
              class="h-2.5 w-2.5 shrink-0 rounded-full"
              style="background-color: {zoneColorForIndex(i, entries.length)};"
              aria-hidden="true"
            />
            <div>
              <div class="font-medium">{disciplineLabel(e.athlete)}</div>
              {#if !isDeprecatedAthleteName(e.athlete) && e.duration != null}<div class="text-xs text-muted-foreground">{formatEffortDuration(e.duration)}</div>{/if}
            </div>
          </div>
        </Table.Cell>
        <Table.Cell class="text-right font-medium">{round(e.current, valuePrecision(e.unit))} {e.unit}</Table.Cell>
        <Table.Cell class="text-right text-muted-foreground">{round(e.median, valuePrecision(e.unit))} {e.unit}</Table.Cell>
        <Table.Cell class="text-right text-muted-foreground">{round(e.best, valuePrecision(e.unit))} {e.unit}</Table.Cell>
        <Table.Cell class="text-right">{round(e.percentile)}%</Table.Cell>
      </Table.Row>
    {/each}
  </Table.Body>
</Table.Root>
